import React from 'react';
import { ListGroup, Spinner } from 'react-bootstrap';
import { AddedRoleType, EntityTypeType, UserRoleType } from '~/components/Admin';
import { AddRoles, RoleRow } from '.';

interface UserRolesType {
    show: boolean;
    userId?: null | number;
    entityType: EntityTypeType;
    entityLabel: string;
    addedRoles: AddedRoleType[];
    setAddedRoles: React.Dispatch<React.SetStateAction<AddedRoleType[]>>;
    userRoles?: UserRoleType[];
    loadingRoles?: boolean;
}
export function UserRoles({
    show,
    userId = null,
    entityType,
    entityLabel,
    addedRoles,
    setAddedRoles,
    userRoles = [],
    loadingRoles = false,
}: UserRolesType) {
    const [adding, setAdding] = React.useState(userId === null);

    return !show ? null : (
        <div className="card">
            <div className="card-header">
                {entityLabel} and Roles
                {userId !== null && !adding && (
                    <button
                        className="pull-right btn btn-sm btn-primary"
                        type="button"
                        onClick={() => setAdding(true)}
                    >
                        Add Access
                    </button>
                )}
            </div>
            <div>
                <ListGroup variant="flush">
                    {loadingRoles && (
                        <div className="text-center">
                            <Spinner animation="border" role="status" className="mt-2" />
                        </div>
                    )}
                    <AddRoles
                        show={adding}
                        setAdding={setAdding}
                        addedRoles={addedRoles}
                        setAddedRoles={setAddedRoles}
                        userRoles={userRoles}
                        entityType={entityType}
                        entityLabel={entityLabel}
                        userId={userId}
                    />
                    {userRoles.map((x) => (
                        <RoleRow key={x.id} role={x} entityType={entityType} />
                    ))}
                    {!loadingRoles && !adding && userRoles.length === 0 && (
                        <ListGroup.Item>User is not added to any {entityLabel}</ListGroup.Item>
                    )}
                </ListGroup>
            </div>
        </div>
    );
}
